import { createFileRoute } from '@tanstack/react-router';
import { BrandingLibraryPage } from '@/pages/member-portal/branding/BrandingLibraryPage';

// Branding assets viewer — sectioned member-facing asset library.
function MemberPortalBrandingRoute() {
	return <BrandingLibraryPage />;
}

export const Route = createFileRoute('/_authenticated/_app/member-portal/branding')({
	component: MemberPortalBrandingRoute,
});
